import React, { useState, useEffect, Suspense } from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  useToast,
  Switch,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  SimpleGrid,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tooltip,
  Wrap,
  useDisclosure,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';
import { FaSave, FaEdit, FaTrash, FaFilePdf } from 'react-icons/fa';
import {
  FiChevronDown,
  FiArrowDown,
  FiDollarSign,
  FiUser,
  FiUsers,
  FiSettings,
  FiShare2,
  FiPrinter,
  FiWatch,
  FiArrowUp,
} from 'react-icons/fi';
import HistorialModal from 'views/Predio/HistorialdeCambios';
import HistorialPagosAP from 'views/Pagos/HistorialPagosAgua';
import CrearActualizarToma from 'views/AguaPotable/AltaToma';

interface Propietario {
  id?: string;
  idTipoContribuyente?: string;
  idTipoPropietario?: number;
  correoElectronico?  :string;
  idTipoVulnerable?: number;
  nombre: string;
  primerApellido: string;
  segundoApellido?: string;
  razonSocial?: string;
  rfc: string;
  curp?: string;
  telefono: string;
  esTitular: boolean;
  PropietarioPredio?: Array<{
    id: string;
    idClaveCatastral: string;
    idPropietario: string;
    ClaveCatastral: {
      id: string;
      claveCatastralEstandar: string;
      cuentaPredial: number;
      fechaActualizacion: string;
      usuario: string;
    };
  }>;
}

interface PropietarioDetailsProps {
  propietarioId?: string; // Ahora es opcional
}

const PropietarioDetails: React.FC<PropietarioDetailsProps> = ({
  propietarioId,
}) => {
  const [propietario, setPropietario] = useState<Propietario>({
    nombre: '',
    primerApellido: '',
    segundoApellido: '',
    razonSocial: '',
    correoElectronico:'',
    rfc: '',
    curp: '',
    telefono: '',
    esTitular: true,
    idTipoVulnerable: 1,
    idTipoPropietario: 1,
    idTipoContribuyente: 'F',
  });
  const [isEditing, setIsEditing] = useState(!propietarioId); // Activar edición si es nuevo
  const toast = useToast();
  const {
    isOpen: isBajaOpen,
    onOpen: onBajaOpen,
    onClose: onBajaClose,
  } = useDisclosure();

  const {
    isOpen: isHistorialPagosAPOpen,
    onOpen: onHistorialPagosAPOpen,
    onClose: onHistorialPagosAPClose,
  } = useDisclosure();

  useEffect(() => {
    if (propietarioId) {
      const fetchPropietario = async () => {
        try {
          const response = await fetch(
            `http://52.91.130.91:5000/api/propietarios/view/${propietarioId}`,
          );
          const data = await response.json();
          console.log(data);
          setPropietario(data);
        } catch (error) {
          console.error('Error fetching propietario:', error);
          toast({
            title: 'Error',
            description: 'No se pudieron cargar los datos del propietario.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      };
      fetchPropietario();
    }
  }, [propietarioId, toast]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPropietario((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = () => {
    setPropietario((prev) => ({ ...prev, esTitular: !prev.esTitular }));
  };

  const handleSave = async () => {
    try {
      const url = propietarioId
        ? `http://52.91.130.91:5000/api/propietarios/propietario/${propietarioId}`
        : `http://52.91.130.91:5000/api/propietarios`;

      const method = propietarioId ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(propietario),
      });

      if (response.ok) {
        toast({
          title: propietarioId ? 'Actualización exitosa' : 'Creación exitosa',
          description: propietarioId
            ? 'Los datos del propietario se han actualizado.'
            : 'El nuevo propietario se ha creado.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        if (!propietarioId) {
          setPropietario({
            nombre: '',
            primerApellido: '',
            segundoApellido: '',
            razonSocial: '',
            idTipoVulnerable: 1,
            idTipoPropietario: 1,
            idTipoContribuyente: 'F',
            rfc: '',
            curp: '',
            telefono: '',
            esTitular: false,
          });
        }
        setIsEditing(false);
      } else {
        throw new Error('Error en la operación');
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo guardar la información.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      p={6}
      bg="white"
      borderRadius="md"
      boxShadow="md"
      maxW="1000px"
      mx="auto"
    >
      <Heading as="h2" size="lg" mb={4}>
        {propietarioId ? 'Detalles del Propietario' : 'Crear Propietario'}
      </Heading>

      <Wrap>
        <Menu>
          <MenuButton
            as={Button}
            colorScheme="orange"
            rightIcon={<FiChevronDown />}
          >
            Agua Potable
          </MenuButton>
          <MenuList>
            <MenuItem icon={<FiArrowUp />} onClick={onBajaOpen}>
              Alta de Toma
            </MenuItem>
            <MenuItem icon={<FiDollarSign />} onClick={onHistorialPagosAPOpen}>
              Historial de pagos agua potable
            </MenuItem>
            {/* <MenuItem icon={<FiDownload />}>Historial de Propietarios</MenuItem> */}
          </MenuList>
        </Menu>
      </Wrap>

      <Modal isOpen={isBajaOpen} onClose={onBajaClose} size="5xl">
        <ModalOverlay />
        <ModalContent
          bg="transparent" // Hace la modal completamente transparente
          boxShadow="none" // Elimina cualquier sombra
        >
          <ModalCloseButton />

          <ModalBody p={0}>
            <Suspense fallback={<Spinner />}>
              <CrearActualizarToma idPropietario={Number(propietarioId)}  alta={true} />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isHistorialPagosAPOpen}
        onClose={onHistorialPagosAPClose}
        size="3xl"
      >
        <ModalOverlay
          bg="rgba(0, 0, 0, 0.3)" // Ajusta la opacidad del fondo (0.3 = 30%)
        />
        <ModalContent
          bg="transparent" // Hace la modal completamente transparente
          boxShadow="none" // Elimina cualquier sombra
        >
          <ModalBody p={0}>
            {' '}
            {/* Elimina padding extra */}
            <HistorialPagosAP idClaveCatastral={propietarioId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} pt={5}>
        <FormControl>
          <FormLabel>Nombre</FormLabel>
          <Input
            name="nombre"
            value={propietario.nombre}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Primer Apellido</FormLabel>
          <Input
            name="primerApellido"
            value={propietario.primerApellido}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Segundo Apellido</FormLabel>
          <Input
            name="segundoApellido"
            value={propietario.segundoApellido || ''}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Razón Social</FormLabel>
          <Input
            name="razonSocial"
            value={propietario.razonSocial || ''}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>RFC</FormLabel>
          <Input
            name="rfc"
            value={propietario.rfc}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>CURP</FormLabel>
          <Input
            name="curp"
            value={propietario.curp || ''}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>ID Tipo Contribuyente</FormLabel>
          <Input
            name="idTipoContribuyente"
            value={propietario.idTipoContribuyente}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>ID Tipo Vulnerable</FormLabel>
          <Input
            name="idTipoVulnerable"
            value={propietario.idTipoVulnerable}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Teléfono</FormLabel>
          <Input
            name="telefono"
            value={propietario.telefono}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Correo Electronico</FormLabel>
          <Input
            name="correoElectronico"
            value={propietario.correoElectronico}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center">
          <FormLabel>Es Titular</FormLabel>
          <Switch
            isChecked={propietario.esTitular}
            onChange={handleSwitchChange}
          />
        </FormControl>
      </SimpleGrid>
      <Heading as="h3" size="md" mt={6} mb={4}>
        Detalles de Clave Catastral
      </Heading>
      <Table variant="striped" colorScheme="teal">
        <Thead>
          <Tr>
            <Th>ID Catastral</Th>
            <Th>Clave Catastral Estandar</Th>
            <Th>Cuenta Predial</Th>
            <Th>Fecha Actualización</Th>
            {/* <Th>Usuario</Th> */}
          </Tr>
        </Thead>
        <Tbody>
          {propietario.PropietarioPredio?.map((predio) => (
            <Tr key={predio.idClaveCatastral}>
              <Td>{predio.idClaveCatastral}</Td>
              <Td>{predio.ClaveCatastral.claveCatastralEstandar}</Td>
              <Td>{predio.ClaveCatastral.cuentaPredial}</Td>
              <Td>
                {new Date(
                  predio.ClaveCatastral.fechaActualizacion,
                ).toLocaleDateString()}
              </Td>
              {/* <Td>{predio.ClaveCatastral.usuario}</Td> */}
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Button colorScheme="blue" mt={6} onClick={handleSave}>
        {propietarioId ? 'Guardar Cambios' : 'Crear Propietario'}
      </Button>
    </Box>
  );
};

export default PropietarioDetails;
